var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircuit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M83.8,101.05H60.12L46.7,87.63M30.91,80.52a8.69,8.69,0,1,1,8.69,8.69A8.69,8.69,0,0,1,30.91,80.52Zm101.83,30.79h23.68l13.42,13.43M132,70.26v73.42m53.68-11.84a8.69,8.69,0,1,1-8.69-8.69A8.68,8.68,0,0,1,185.63,131.84Zm-45,22.1a8.68,8.68,0,1,1-8.68-8.68A8.68,8.68,0,0,1,140.63,153.94Zm0-92.37A8.68,8.68,0,1,1,132,52.89,8.68,8.68,0,0,1,140.63,61.57ZM107.48,48.94V131L90.12,142.1v27.63M74.33,66.31l11,11v36.32l-18,9.47v23.69m9.37,8.68A8.69,8.69,0,1,1,68,146.84,8.69,8.69,0,0,1,76.7,155.52Zm22.1,26.06a8.68,8.68,0,1,1-8.68-8.69A8.68,8.68,0,0,1,98.8,181.58ZM116.17,40.26a8.69,8.69,0,1,1-8.69-8.68A8.69,8.69,0,0,1,116.17,40.26ZM76.7,59.2A8.69,8.69,0,1,1,68,50.52,8.69,8.69,0,0,1,76.7,59.2Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircuit);
export default __webpack_public_path__ + "static/media/CIRCUIT.41550c995bc4883027d505a9bb178d0b.svg";
export { ForwardRef as ReactComponent };